import { render, staticRenderFns } from "./Wrong.vue?vue&type=template&id=a9a470c6"
import script from "./Wrong.vue?vue&type=script&lang=js"
export * from "./Wrong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports